<mat-slide-toggle [(ngModel)]="valore"
                  (mousedown)="$event.stopPropagation()"
                  [color]="color"
                  [disabled]="block ? block : false"
                  (change)="valueChange($event.checked)">
  {{testo}}
</mat-slide-toggle>
